import { formatYearMonthDay } from '@optools/utils/datetime';
import { z } from 'zod';

export const dateSchema = z.object({
  date: z.string().default(formatYearMonthDay(new Date())),
});
